import { Accordion, Mobile, Burger, Carousel_CoreInit} from './core'
import Locator from './modules/locator'
import './modules/header'
import './modules/newsletter-form'
import './plugins/table-of-contents'
import './plugins/masked-title'
import './plugins/page-product'
import './plugins/parallax'

$(function() {
  Carousel_CoreInit([
    {
      classSelector: 'carousel--style--gallery',
      swiperOptions: {
        loopAdditionalSlides : 6,
      },
    },
  ])

  $.mlmi = {
    mobile: new Mobile(),
    burger: undefined,
  }

  /* Header */
  $('.header').each(function() {
    $(this).Header()
  })

  /* Accordions */
  Accordion.init()

  /* Locator */
  Locator.init()

  /* Newsletter form */
  $('.newsletter-form').each(function() {
    $(this).NewsletterForm()
  })

  /* Pull up section */
  $('.pull-up-desktop, .pull-up-mobile').each(function() {
    $(this).closest('.page-section').prev('.page-section').addClass('previous-pull-up');
  })

  /* Push down element */
  $('.push-down').each(function() {
    $(this).closest('.text-content').addClass('push-down-wrapper');
  })

  /* Pull under */
  $('.pull-under').each(function() {
    $(this).closest('.row').addClass('push-under-wrapper');
  })

  /* Middle divider */
  $('.middle-divider').each(function() {
    $(this).closest('.text-content').addClass('middle-divider-wrapper');
  })

  /* Mobile image alignment */
  $('.mobile-image-right').each(function() {
    $(this).wrap('<div class="mobile-image-right-wrapper"></div>');
  })
  $('.mobile-image-left').each(function() {
    $(this).wrap('<div class="mobile-image-left-wrapper"></div>');
  })

  /* Table of contents */
  $('.table-of-contents').each(function() {
    $(this).TableOfContents()
  })

  /* Table of contents */
  $('body.page-product').each(function() {
    $(this).pageProduct()
  })

  /* Clic anchor */
  $('a[href^="#"]').on('click', function() {
    if ($($(this).attr('href')).length) {
      let targetTop = $($(this).attr('href')).offset().top - $('.header--fixed').height() - 20
      $('html, body').scrollTo(targetTop, 400, 5)
      return false
    }
  })

  /* Masks */
  $('.--masked-title').each(function() {
    $(this).MaskedTitle()
  })

  /* Middle divider */
  $('.overlapping-images').each(function() {
    if ($(this).css('background-position') == '100% 0%') {
      $(this).addClass('top-right')
    } else if ($(this).css('background-position') == '0% 100%') {
      $(this).addClass('bottom-left')
    } else if ($(this).css('background-position') == '0% 50%') {
      $(this).addClass('center-left')
    }
  })

  /* Fade-in elements */
  $('.fade-in, .slide-in').each(function() {
    $(this).FadeIn()
  })

  $('.overlapping-images .picture').each(function() {
    $(this).parallax(-.4, 'desktop')
    $(this).parallax(-.2, 'mobile')
  })
})
